import styled, { css } from 'styled-components';
import FlexBox from '../FlexBox';
import Text from '../Text';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import SortableList from 'react-easy-sort';

export const Box = styled(FlexBox)`
  width: 100%;
  border-radius: 4px;
  background: #fff;
  box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25),
    0px 4px 4px 0px rgba(0, 0, 0, 0.25);
  padding: 19px 21px;
  box-sizing: border-box;
  position: relative;
`;

export const BoxTitleContainer = styled(FlexBox)`
  width: 100%;
  gap: 14px;
`;

export const HouseIcon = styled(FontAwesomeIcon)`
  font-size: 20px;
  color: #d47e5b;
`;

export const BoxAddress = styled(Text)`
  font-weight: 500;
  text-transform: capitalize;
`;

export const BoxCity = styled(Text)`
  font-weight: 500;
  text-transform: capitalize;
`;

export const BoxRemove = styled.div`
  position: absolute;
  top: 8px;
  right: 11px;
  cursor: pointer;
`;

export const RemoveIcon = styled(FontAwesomeIcon)`
  font-size: 16px;
  color: #d47e5b;
`;
